import React from 'react';

import { Typography } from '@mui/material';
import dayjs from 'dayjs';

import { DatePicker } from '../DatePicker';

import { DateRangePickerContainer } from './index.styles';

interface DateRangePickerProps {
  startDate: dayjs.Dayjs | null;
  endDate: dayjs.Dayjs | null;
  onStartDateChange: (date: dayjs.Dayjs | null) => void;
  onEndDateChange: (date: dayjs.Dayjs | null) => void;
}

const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: DateRangePickerProps) => {
  const handleStartDateChange = (date: dayjs.Dayjs | null) => {
    onStartDateChange(date);
    if (date && endDate && date.isAfter(endDate)) {
      // Ensure that endDate is after startDate
      onEndDateChange(date);
    }
  };

  const handleEndDateChange = (date: dayjs.Dayjs | null) => {
    onEndDateChange(date);
    if (startDate && date && date.isBefore(startDate)) {
      // Ensure that startDate is before endDate
      onStartDateChange(date);
    }
  };

  return (
    <DateRangePickerContainer>
      <DatePicker
        label="Start Date"
        value={startDate}
        onChange={handleStartDateChange}
        maxDate={endDate}
      />
      <Typography variant="h6"> - </Typography>
      <DatePicker
        label="End Date"
        value={endDate}
        onChange={handleEndDateChange}
        minDate={startDate}
      />
    </DateRangePickerContainer>
  );
};

export default DateRangePicker;
